import { render, staticRenderFns } from "./IconArrowCircleDownSolid.vue?vue&type=template&id=8b984a08"
import script from "./IconArrowCircleDownSolid.vue?vue&type=script&lang=js"
export * from "./IconArrowCircleDownSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports